import vmClient from 'app/services/vmClient';
import * as Reducers from 'app/remote/generic/reducer';
import * as Actions from 'app/remote/generic/actions';
import * as Reconcile from 'app/remote/generic/reconcile';
import * as Upload from 'app/remote/generic/upload';
import { ENTITY_PREFIX, REMOTE_PREFIX } from 'app/remote/constants';

function getLocalMap(state) {
  return state.get(ENTITY_PREFIX);
}

export function getRemoteMap(state) {
  return state.getIn([REMOTE_PREFIX, ENTITY_PREFIX]);
}

function updateLocalMap(state, f) {
  return state.update(ENTITY_PREFIX, f);
}

const config = {
  prefix: REMOTE_PREFIX,
  vmClient,
  getLocalMap,
  getRemoteMap,
  updateLocalMap,
};


export const updateFromServer    = Actions.updateFromServer;
export const savedToServer       = Actions.savedToServer;
export const entityDeleted       = Actions.entityDeleted;
export const discardLocalChanges = Actions.discardLocalChanges;

export const recordize           = vmClient.recordize.bind(vmClient);

export const serializeEdits      = Upload.makeSerializeEdits(config);
export const deepSerializeEdits  = Upload.makeSerializeEdits({
  ...config,
  serializeShared: true,
});
export const serializeEntity     = vmClient.serializeEntity.bind(vmClient);

export const remoteStateReducer  = Reducers.makeRemoteStateReducer(config);
export const storeReducer        = Reducers.makeStoreReducer(config);

export const hasEdits            = Reconcile.makeHasEdits(config);
export const hasUnsavedChanges   = Reconcile.makeHasUnsavedChanges(config);
export const logVersion          = Reconcile.makeLogVersion(config);

/**
 * @deprecated - Prefer parseSupplementalData.
 */
export const parseSupplementary = (meta, id, attr) => {
  if (meta && meta.supplementary) {
    const metaForId = meta.supplementary[id];
    if (metaForId) {
      return metaForId[attr];
    }
  }

  return null;
};
